/**
 * Parses a display name that may be a JSON-encoded localization map
 * (e.g. {"en":"7-Day Pass","es":"pase de 7 días"}) and returns the value
 * for the given language, falling back to "en" then the raw string.
 */
export const getLocalizedDisplayString = (
    displayName: string | undefined,
    language: string
): string | undefined => {
    if (!displayName) return displayName;
    try {
        const parsed = JSON.parse(displayName);
        if (typeof parsed === "object" && parsed !== null) {
            return parsed[language] ?? parsed["en"] ?? displayName;
        }
    } catch {
        // not JSON — use as-is
    }
    return displayName;
};
